module.exports = __webpack_public_path__ + "images/hema7f744b2e56865e07ff343cfe8365925b.png";